import { callApi } from 'loankeeper-common/api'

// export const search = ({ title, balcodeid, accno, personalno, ccy, typeid, nodeid, statusid, page }) =>
//   callApi('acc_account_search', {
//     method: 'post',
//     params: {
//       Title: title,
//       BalCodeID: balcodeid,
//       AccNo: accno,
//       PersonalNo: personalno,
//       CCY: ccy,
//       TypeID: typeid,
//       NodeID: nodeid,
//       StatusID: statusid,
//       page,
//     },
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const operations = ({ ID, hash, action }) =>
//   callApi('acc_entry_oper', {
//     params: {
//       ID,
//       HashSum_EntryID_: hash,
//       action,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const details = ({ ID, hash, page = 'base', ...rest }) =>
//   callApi('acc_account_view', {
//     params: {
//       AccountID: ID,
//       HashSum_AccountID_: hash,
//       page,
//       ...rest,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const creditDetails = ({ ID, hash }) =>
  callApi('acc_account_view', {
    params: {
      CreditAccID: ID,
      HashSum_CreditAccID_: hash,
      page: 'base',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const getBalance = ({ ID, hash } = {}) =>
//   ID &&
//   hash &&
//   callApi('acc_account_view', {
//     params: {
//       AccountID: ID,
//       HashSum_AccountID_: hash,
//       page: 'balance',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const debitDetails = ({ ID, hash }) =>
  callApi('acc_account_view', {
    params: {
      DebitAccID: ID,
      HashSum_DebitAccID_: hash,
      page: 'base',
    },
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const statement = ({ ID, hash, ...rest }) =>
//   callApi('acc_account_view', {
//     params: {
//       AccountID: ID,
//       HashSum_AccountID_: hash,
//       page: 'stmt',
//       ...rest,
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

export const print = (params) =>
  callApi('acc_account_view', {
    params,
    method: 'post',
    body: {},
    headers: {
      'Content-type': 'application/x-www-form-urlencoded',
    },
  })

// export const add = (params) =>
//   callApi('acc_account_add', {
//     params,
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const addPermission = (params) =>
//   callApi('acc_account_oper', {
//     params: {
//       ...params,
//       action: 'accesspermadd',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })

// export const deletePermission = (params) =>
//   callApi('acc_account_oper', {
//     params: {
//       ...params,
//       action: 'accesspermdelete',
//     },
//     method: 'post',
//     body: {},
//     headers: {
//       'Content-type': 'application/x-www-form-urlencoded',
//     },
//   })
